import { Analytics } from '@cobliteam/analytics';

import { ChecklistFieldType } from '@cobliteam/api-lib';
import { useTranslation } from '@cobliteam/i18n';
import { Button, DropdownMenu } from '@cobliteam/ui/components';

import Icon from '@cobliteam/ui/icons';

import type { FormValues } from '../checklistSchema';

interface ChecklistItemDropdownProps {
  addItem: (value: FormValues['items'][0]) => void;
}

const ChecklistItemDropdown = ({ addItem }: ChecklistItemDropdownProps) => {
  const { t } = useTranslation('checklists');
  const onClick = (value: ChecklistFieldType) => {
    Analytics.track('Checklist Item Dropdown Clicked', {
      type: value,
    });

    const hasSelectOptions = value === ChecklistFieldType.SINGLE_SELECT || value === ChecklistFieldType.MULTI_SELECT;

    addItem({
      title: '',
      type: value,
      required: false,
      shouldRequestPhotos: false,
      content: {
        value: null,
        checked: null,
        label: null,
        options: hasSelectOptions ? [{ label: '' }] : null,
      },
    });
  };

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <Button color='default' size='sm' variant='outlined' startIcon={<Icon name='plus' />}>
          {t('add_item')}
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align='start'>
        <DropdownMenu.Item onClick={() => onClick(ChecklistFieldType.TEXT)}>
          <DropdownMenu.Icon icon={<Icon name='text' />} />
          <DropdownMenu.Label>{t('text_field')}</DropdownMenu.Label>
        </DropdownMenu.Item>

        <DropdownMenu.Item onClick={() => onClick(ChecklistFieldType.CHECK)}>
          <DropdownMenu.Icon icon={<Icon name='circle-check' />} />
          <DropdownMenu.Label>{t('mark_as_done')}</DropdownMenu.Label>
        </DropdownMenu.Item>

        <DropdownMenu.Item onClick={() => onClick(ChecklistFieldType.MULTI_SELECT)}>
          <DropdownMenu.Icon icon={<Icon name='list-checks' />} />
          <DropdownMenu.Label>{t('multiple_choice')}</DropdownMenu.Label>
        </DropdownMenu.Item>

        <DropdownMenu.Item onClick={() => onClick(ChecklistFieldType.SINGLE_SELECT)}>
          <DropdownMenu.Icon icon={<Icon name='circle-dot' />} />
          <DropdownMenu.Label>{t('single_selection')}</DropdownMenu.Label>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default ChecklistItemDropdown;
